import {
  AFFORDABILITY_TABLE_DATA_SUCCESS,
  AFFORDABILITY_TABLE_DATA_FAILURE,
  AFFORDABILITY_TABLE_DATA_REQUEST,
  AFFORDABILITY_TABLE_DATA_LOADING,
} from '../actionTypes';

export const fetchMPINTableDataRequest = (payload: any, key: string) => ({
  type: AFFORDABILITY_TABLE_DATA_REQUEST,
  key,
  payload,
});
export const setMPINTableDataLoading = (payload: any, key: string) => ({
  type: AFFORDABILITY_TABLE_DATA_LOADING,
  key,
  payload,
});
export const setMPINTableDataError = (payload: any, key: string) => ({
  type: AFFORDABILITY_TABLE_DATA_FAILURE,
  key,
  payload,
});
export const setMPINTableDataSuccess = (payload: any, key: string) => ({
  type: AFFORDABILITY_TABLE_DATA_SUCCESS,
  key,
  payload,
});
